import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import CentersExcelActions, { CentersExcelRedux, CentersExcelTypes } from '../Redux/CentersExcelRedux'
import { notificationFail } from '../Redux/NotificationActions'

const centersExcelCrudObservable = createCRUDObservable({
  mainRedux: CentersExcelRedux,
  reduxPath: 'centersExcel',
})

const excelEpic = (action$, store, { Api }) =>
  action$.ofType(CentersExcelTypes.CentersExcelRequest)
    .mergeMap(({ path, centerId }) => (
      Observable
        .fromPromise(Api.centersExcel.getCentersExcel(path, centerId)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            CentersExcelActions.CentersExcelSuccess(),
          ]
        })
    ))

export const centersExcelObservers = Object.assign({}, centersExcelCrudObservable.observers, {})

export const centersExcelEpic = combineEpics(
  excelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CentersExcelObservable.js